module.exports = __webpack_public_path__ + "static/img/logo_11.4387baa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo/logo_11.png
// module id = dgxK
// module chunks = 1